// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
import * as ActiveStorage from "@rails/activestorage"
import "./controllers"
import "./lib/page_transitions"
import "./lib/click_counts"
import "./lib/analytics"

ActiveStorage.start()
